
// for security
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const GET_USER_DATA = 'getUserData';

// for app dashboard
export const CONTROLS = 'controls';




// WEBPACK FOOTER //
// ./src/store/types.js